import React, {useEffect, useState} from 'react';
import apiClient from "../../http-common";
import { useQuery } from "react-query";

export const Histories = () => {
    const refresh = () => window.location.reload();

    let theme = localStorage.getItem('MARVEL CREST LIMITED-Theme');
    const [currentTheme, setCurrentTheme] = useState(theme);

    const { isLoading: isLoadingHistories, refetch: getHistories } = useQuery(
        "account-histories",
        async () => {
          return await apiClient.get("/api/histories");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
    
                let accountHistories = {
                    'withdrawals': res.data.withdrawals,
                    'investments' : res.data.investments,
                    'referrals' : res.data.referrals,
                    'plans' : res.data.plans,
                    'wallets' : res.data.wallets,
                    'toasts': res.data.toasts,
                    'investmentHistory': res.data.investmentHistory
                }
                localStorage.setItem('binaryfair-account-histories', JSON.stringify(accountHistories));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
                const toastEvent = new Event('toastEvent');
                window.dispatchEvent(toastEvent);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
      useEffect(() => {
        if (document.readyState === "complete") {
            let language = document.getElementsByClassName('goog-te-combo');
            if (language.length > 0) {
                language[0].classList.add("bg-theme");
                language[0].classList.add("color-theme");  
            }
            
        }
        
        getHistories();
        window.addEventListener('themeChanged', function (e) {
            let theme = localStorage.getItem('MARVEL CREST LIMITED-Theme');
            if (theme !== null) {
                if (theme === 'dark-mode') {
                   setCurrentTheme('dark-mode')
                }else{
                   setCurrentTheme('light-mode') 
                }
               
            }             
       }, false);
      }, [isLoadingHistories]);

      return (
          <div>
                {currentTheme === "dark-mode"
                ?
                    <div className="icon bg-theme color-theme rounded-circle ">
                        {isLoadingHistories ?
                        <img style={{marginTop: "10px", height: '30px'}} src='/images/logo/logo-white.png' alt="logo" />
                        :
                        <img style={{marginTop: "10px", height: '30px'}} onClick={refresh} src='/images/logo/logo-white.png' alt="logo" />
                        }
                    </div>
                :
                    <div className="icon bg-theme color-theme rounded-circle ">
                        {isLoadingHistories ?
                        <img style={{marginTop: "10px", height: '30px'}} src='/images/logo/logo-dark.png' alt="logo" />
                        :
                        <img style={{marginTop: "10px", height: '30px'}} onClick={refresh} src='/images/logo/logo-dark.png' alt="logo" />
                        }
                    </div>
                }
          </div>
            
      )
}

export const referralsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.referrals;
    }
    return accountHistory;

}

export const plansHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.plans;
    }
    return accountHistory;

}

export const walletsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.wallets;
    }
    return accountHistory;

}

export const investmentsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.investments;
    }
    return accountHistory;
}

export const investmentChartHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.investmentHistory;
    }
    return accountHistory;
}

export const withdrawalsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.withdrawals;
    }
    return accountHistory;
}


export const toastsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.toasts;
    }
    return accountHistory;
}






